import { GridColDef } from "@mui/x-data-grid-pro";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  ArrowDownIcon,
  Divider,
  GKClientDataGrid,
  StatusField,
  Typography,
} from "components";
import { map } from "lodash";
import { useFormContext } from "react-hook-form";
import { moneyCommaSeparator, moneyCommaSeparatorPoint } from "utils";
import { extraColumnsField } from "utils/helpers";

const GenerateTradeCompany = () => {
  const form = useFormContext();

  const columns: GridColDef[] = [
    { ...extraColumnsField("Company Name", "company", 200, 1) },
    {
      ...extraColumnsField("Portfolio WT.", "portfolioWeightage", 120, 1),
      type: "number",
      valueGetter: (params) =>
        `${Number(params?.row?.portfolioWeightage)?.toFixed(2)}%`,
    },
    {
      ...extraColumnsField("Ledger Balance (₹)", "ledgerBalance", 150, 1),
      type: "number",
      valueFormatter: (params) => moneyCommaSeparator(params.value),
    },
    {
      ...extraColumnsField("trans. type", "transaction type", 100, 1),
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return <StatusField statusString={params.row["transaction type"]} />;
      },
    },
    {
      ...extraColumnsField("Deviation", "deviationPercent", 100, 1),
      type: "number",
      valueGetter: (params) =>
        `${Number(params?.row?.deviationPercent)?.toFixed(2)}%`,
    },
    {
      ...extraColumnsField("Qty", "quantity", 100, 1),
      type: "number",
      valueFormatter: (params) => moneyCommaSeparatorPoint(params.value),
      valueGetter: (params) => params.row.quantity || "0",
    },
    {
      ...extraColumnsField("Trade Amount (₹)", "amount", 150, 1),
      type: "number",
      valueFormatter: (params) => moneyCommaSeparator(params.value),
    },
    {
      ...extraColumnsField("After Trade WT.", "afterTradeWeightage", 150, 1),
      type: "number",
      valueGetter: (value) => moneyCommaSeparator(value.value),
    },
  ];

  return map(form.getValues("generateTradeResponse"), (dataItem, index) => {
    return (
      <Accordion sx={{ boxShadow: "none", borderBottom: "1px solid #D5DEE5" }}>
        <AccordionSummary expandIcon={<ArrowDownIcon />} id={index}>
          <Typography
            fontSize={14}
            fontWeight={500}
            display={"flex"}
            alignItems="center"
            gap={"12px"}
          >
            {dataItem?.clientName || "-"}
            <Typography
              fontSize={12}
              fontWeight={500}
              color=" #697586"
              display={"flex"}
              alignItems="center"
              gap={"12px"}
            >
              <Divider orientation="vertical" sx={{ height: 15 }} />
              {dataItem.portfolioName} - {dataItem.portfolioCode}
            </Typography>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <GKClientDataGrid
            name="modelCompanyAllocationCreateOrder"
            density="compact"
            columns={columns}
            rows={
              dataItem?.plan?.map((data: any, i: number) => {
                return {
                  ...data,
                  index: i,
                  id: i,
                };
              }) || []
            }
          />
        </AccordionDetails>
      </Accordion>
    );
  });
};

export default GenerateTradeCompany;
